import { render, staticRenderFns } from "./goster.vue?vue&type=template&id=3161dd40&"
import script from "./goster.vue?vue&type=script&lang=js&"
export * from "./goster.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports